import { render, staticRenderFns } from "./back_head.vue?vue&type=template&id=1e503be4"
import script from "./back_head.vue?vue&type=script&lang=js"
export * from "./back_head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports